<template>
  <div>
    <div>
      <img :src="imgSrc" id="imgSelf" v-show="imgSrc" />
      <!-- <canvas v-show="imgSrc" id="showImg"></canvas> -->
      <div class="box" @click="getLocation">
        <img src="https://cdn.yxvzb.com/WEB/SaaS/images/gps.png" />
        <span>请{{ imgSrc ? '重新' : '点击' }}获取地理位置</span>
      </div>
    </div>
    <van-popup
      v-model="showFlag"
      position="bottom"
      :style="{ height: '100%' }"
      get-container="body"
    >
      <div id="container" ref="container"></div>
      <van-field
        v-model="mapSearchVal"
        placeholder="搜索地点"
        class="searchBox"
        left-icon="search"
        @input="searchMap"
      />
      <ul class="infoDiv">
        <li
          v-for="(item, index) in searchResult"
          :key="index"
          @click="choose(item, index)"
        >
          <p class="nameBox">{{ item.name || item.title }}</p>
          <p class="addressBox">{{ item.address }}</p>
          <img
            src="//cdn.yxvzb.com/WEB/SaaS/images/nike.png"
            v-if="index == activeIndex"
          />
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable no-undef */
// import { castUrl } from '@/api/index';
export default {
  props: {
    countIndex: {
      type: Number
    },
    value: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      imgSrc: '',
      latitude: '',
      longitude: '',
      geolocation: null,
      map: null,
      showFlag: false,
      mapSearchVal: '',
      searchService: null,
      marker: null,
      cityName: '',
      searchResult: [],
      backInfo: {},
      activeIndex: null,
      markers: []
    };
  },
  methods: {
    async finish() {
      //点击完成
      let res = this.map.getCenter();
      this.backInfo = {
        longitude: res.lng,
        latitude: res.lat
      };
      let imgUrl = `https://apis.map.qq.com/ws/staticmap/v2/?center=${this.backInfo.latitude},${this.backInfo.longitude}&zoom=16&size=685*343&maptype=roadmap&markers=size:large|icon:https://lbs.qq.com|color:0xFFCCFF|label:k|${this.backInfo.latitude},${this.backInfo.longitude}&key=ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU`;
      // 无该接口
      // let { data } = await castUrl({ imgUrl });
      // this.imgSrc = data;
      // this.backInfo.addressPicUrl = data;
      this.imgSrc = `https://apis.map.qq.com/ws/staticmap/v2/?center=${this.backInfo.latitude},${this.backInfo.longitude}&zoom=16&size=685*343&maptype=roadmap&markers=size:large|icon:https://lbs.qq.com|color:0xFFCCFF|label:k|${this.backInfo.latitude},${this.backInfo.longitude}&key=ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU`;
      this.backInfo.addressPicUrl = this.imgSrc;
      this.backInfo.count = this.countIndex;
      this.$emit('finishMap', this.backInfo);
      this.showFlag = false;
    },
    choose(item, index) {
      //选中搜索结果，展示地图
      if (this.markers) {
        //清除所有点
        for (let i in this.markers) {
          this.markers[i].setMap(null);
        }
      }
      if (!item.latLng) {
        item.latLng = new qq.maps.LatLng(item.location.lat, item.location.lng);
      }
      this.setMarker(item.latLng);
      this.map.panTo(item.latLng);
      this.map.zoomTo(18);
      this.activeIndex = index;
    },
    setMarker(center) {
      //为地图设置标记
      let marker = new qq.maps.Marker({
        position: center,
        map: this.map
      });
      marker.setVisible(true);
      marker.setTitle('我的位置');
      this.markers.push(marker);
    },
    getLocation() {
      //获取经纬度
      let geolocation = new qq.maps.Geolocation(
        'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU',
        'demo'
      );
      geolocation.getLocation(
        res => {
          this.cityName = res.city;
          this.longitude = res.lng;
          this.latitude = res.lat;
          this.init();
        },
        err => {
          console.log(err);
        }
      );
      this.init();
    },
    dragMap() {
      //拖动地图事件
      let center2 = this.map.getCenter();
      if (this.markers) {
        //清除所有点
        for (let i in this.markers) {
          this.markers[i].setMap(null);
        }
      }
      this.setMarker(center2);
      const KEY = 'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU'; //key 秘钥自己申请
      let url =
        'https://apis.map.qq.com/ws/geocoder/v1?&poi_options=address_format=short&get_poi=1';
      let locationdata = center2.lat.toFixed(4) + ',' + center2.lng.toFixed(4); //纬度，经度
      this.$jsonp(url, {
        key: KEY,
        callbackName: 'QQmap',
        output: 'jsonp',
        location: locationdata
      })
        .then(res => {
          this.searchResult = res.result.pois;
        })
        .catch(err => {
          console.log(err);
        });
    },
    init() {
      //渲染地图
      this.markers = [];
      this.showFlag = true;
      let center = new qq.maps.LatLng(this.latitude, this.longitude);
      this.map = new qq.maps.Map(document.getElementById('container'), {
        //实例化地图
        center: center,
        zoom: 18,
        draggable: true,
        scaleControl: true,
        mapTypeControlOptions: {
          mapTypeIds: []
        }
      });
      this.dragMap();
      let cancel = document.createElement('div');
      let finish = document.createElement('finish');
      cancel.className = 'cancel';
      cancel.innerHTML = '取消';
      cancel.style.marginTop = '.2rem';
      cancel.style.marginLeft = '.2rem';
      cancel.style.color = 'grey';
      cancel.style.fontSize = '.4rem';
      cancel.style.background = '#fff';
      cancel.style.borderRadius = '.1rem';
      cancel.style.padding = '0 .1rem';
      finish.className = 'finish';
      finish.innerHTML = '完成';
      finish.style.marginTop = '.2rem';
      finish.style.marginRight = '.2rem';
      finish.style.color = '#fff';
      finish.style.fontSize = '.4rem';
      finish.style.background = 'rgb(50, 184, 77)';
      finish.style.borderRadius = '.1rem';
      finish.style.padding = '0 .1rem';
      this.map.controls[qq.maps.ControlPosition.TOP_LEFT].push(cancel);
      this.map.controls[qq.maps.ControlPosition.TOP_RIGHT].push(finish);
      qq.maps.event.addListener(cancel, 'click', () => {
        //点击取消事件
        this.showFlag = false;
      });
      qq.maps.event.addListener(finish, 'click', () => {
        //点击完成事件
        this.finish();
      });
      this.setMarker(center);
      qq.maps.event.addListener(this.map, 'dragend', () => {
        //拖动地图事件
        this.dragMap();
      });
      var latlngBounds = new qq.maps.LatLngBounds();
      //设置Poi检索服务，用于本地检索、周边检索
      this.searchService = new qq.maps.SearchService({
        //设置搜索
        location: this.cityName,
        //设置搜索页码为0
        pageIndex: 0,
        //设置每页的结果数为5
        pageCapacity: 5,
        //设置动扩大检索区域。默认值true，会自动检索指定城市以外区域。
        autoExtend: false,
        //检索成功的回调函数
        complete: results => {
          //设置回调函数参数
          if (this.markers) {
            for (let i in this.markers) {
              this.markers[i].setMap(null);
            }
          }
          var pois = results.detail.pois;
          this.searchResult = pois;
          for (var j = 0, l = pois.length; j < l; j++) {
            var poi = pois[j];
            //扩展边界范围，用来包含搜索到的Poi点
            latlngBounds.extend(poi.latLng);
            // var marker = new qq.maps.Marker({
            //   map: this.map,
            //   position: poi.latLng
            // });
            // marker.setTitle(j + 1);
            // this.markers.push(marker);
          }
          //调整地图视野
          this.map.fitBounds(latlngBounds);
        },
        //若服务请求失败，则运行以下函数
        error: err => {
          console.log(err);
        }
      });
    },
    searchMap() {
      //搜索地图
      this.activeIndex = null;
      this.searchService.search(this.mapSearchVal);
    }
  },
  created() {
    if (this.value) {
      Object.assign(this.$data, this.value);
      this.imgSrc = this.value.addressPicUrl;
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  width: 9.15rem;
  height: 1.28rem;
  border-radius: 0.16rem;
  border: 2px solid rgba(244, 178, 12, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 0.55rem;
    height: 0.55rem;
    margin-right: 0.11rem;
  }
  span {
    color: #f4b20c;
    font-size: 0.45rem;
  }
}
#imgSelf {
  width: 9.15rem;
  height: 4.57rem;
  margin: 0.43rem auto;
}
.cancel {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  color: grey;
  z-index: 10;
  font-size: 0.4rem;
  background: #fff;
  border-radius: 0.1rem;
  padding: 0 0.1rem;
}
.finish {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  background: rgb(50, 184, 77);
  color: #fff;
  border-radius: 0.1rem;
  padding: 0 0.1rem;
  z-index: 10;
  font-size: 0.4rem;
}
.searchBox {
  text-align: center;
  border: 1px solid #efefef;
  width: 90%;
  background: #efefef;
  margin: 0.27rem auto;
  border-radius: 0.4rem;
  text-align: center;
}
#container {
  width: 100%;
  height: 60%;
}
.infoDiv {
  padding: 0.5rem;
  height: 30%;
  overflow-y: scroll;
  li {
    margin-bottom: 0.27rem;
    position: relative;
    img {
      position: absolute;
      width: 0.6rem;
      height: 0.6rem;
      top: 0.2rem;
      right: 0.1rem;
    }
  }
  .nameBox {
    cursor: pointer;
    font-weight: bold;
    font-size: 0.4rem;
  }
  .addressBox {
    color: lightgrey;
    font-size: 0.27rem;
  }
}
</style>
